import HTTP from '@/utils/http'
import notification from '@/utils/notification'

export async function getVendorPurchases (vendorId) {
  try {
    const response = await HTTP.get('/purchases/vendors', { params: { vendorId } })
    return response.data.data
  } catch (err) {
    return []
  }
}

export async function getPrCurrencies () {
  try {
    const response = await HTTP.silentGet('/purchases/requests/currencies')
    return response.data || {}
  } catch (error) {
    console.error(error)
    return null
  }
}

export async function getPoCurrencies () {
  try {
    const response = await HTTP.silentGet('/purchases/orders/currencies')
    return response.data || {}
  } catch (error) {
    console.error(error)
    return null
  }
}

export async function getPcCurrencies () {
  try {
    const response = await HTTP.silentGet('/purchases/contracts/currencies')
    return response.data || {}
  } catch (error) {
    console.error(error)
    return null
  }
}

export async function getPurchaseDetail (prNumber) {
  try {
    const response = await HTTP.get(`/purchases/requests/${prNumber}`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'pr')
    throw err
  }
}

export async function createPurchaseOrder (request) {
  try {
    await HTTP.post(`/purchases/orders/`, request)
    return true
  } catch (err) {
    notification.handleResponseError(err, 'po')
    return false
  }
}

export async function createContract (request) {
  try {
    await HTTP.post(`/purchases/contracts/`, request)
    return true
  } catch (err) {
    notification.handleResponseError(err, 'contract')
    return false
  }
}

export async function getExternalPO (poNumber) {
  const response = await HTTP.get(`/purchases/orders/${poNumber}`)
  return response.data.data
}

export async function getExternalContract (contractNumber, revision, params) {
  const response = await HTTP.get(`/purchases/contracts/${contractNumber}`, { params: { revision, ...params } })
  return response.data.data
}
